import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from 'react';
import { ResourcesContext } from '../../ResourcesContext';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import { useToasts } from '../../../../../common/Toast';
import { useDialog } from '../../../../../common/Dialog';
import useLocalStorage from '../../../../../hooks/useLocalStorage';
import { APIWebhook } from '../../../../../../../../../typings/Webhook.interface';
const useOnPauseToggle = () => {
  const $ = _c(10);
  const {
    mutateResourceType
  } = useContext(ResourcesContext);
  const {
    addToast
  } = useToasts();
  const showDialog = useDialog();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const [pause_is_running, setPauseIsRunning] = useState(false);
  const [confirm_pause, setConfirmPause] = useLocalStorage("prompt_pause_webhook", true);
  const [confirm_unpause, setConfirmUnpause] = useLocalStorage("prompt_unpause_webhook", true);
  let t0;
  if ($[0] !== HookdeckAPI || $[1] !== addToast || $[2] !== confirm_pause || $[3] !== confirm_unpause || $[4] !== mutateResourceType || $[5] !== pause_is_running || $[6] !== setConfirmPause || $[7] !== setConfirmUnpause || $[8] !== showDialog) {
    t0 = (webhook, pause) => {
      if (pause_is_running) {
        return;
      }
      const apply = () => {
        const promise = pause ? HookdeckAPI.webhooks.pause(webhook.id) : HookdeckAPI.webhooks.unpause(webhook.id);
        setPauseIsRunning(true);
        return promise.then(webhook_0 => {
          addToast("success", `${webhook_0.paused_at ? "Paused" : "Unpaused"} webhook ${webhook_0.full_name}`);
          setPauseIsRunning(false);
          mutateResourceType("webhooks", webhook_0);
        }).catch(() => {
          setPauseIsRunning(false);
          addToast("error", `Failed to ${pause ? "pause" : "unpause"} webhook ${webhook.full_name}`);
        });
      };
      if (pause && confirm_pause) {
        showDialog(() => {
          apply();
          setConfirmPause(false);
        }, _temp, {
          message: "Incoming events will be held, and redelivered when the connection is unpaused. Are you sure you want to pause the connection?"
        });
      } else {
        if (!pause && confirm_unpause) {
          showDialog(() => {
            apply();
            setConfirmUnpause(false);
          }, _temp2, {
            message: "All held events associated with this connection will be sent, and any maximum delivery rate on the destination will be honored. Are you sure you want to unpause the connection?"
          });
        } else {
          apply();
        }
      }
    };
    $[0] = HookdeckAPI;
    $[1] = addToast;
    $[2] = confirm_pause;
    $[3] = confirm_unpause;
    $[4] = mutateResourceType;
    $[5] = pause_is_running;
    $[6] = setConfirmPause;
    $[7] = setConfirmUnpause;
    $[8] = showDialog;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  const onTogglePause = t0;
  return onTogglePause;
};
export default useOnPauseToggle;
function _temp() {
  return null;
}
function _temp2() {
  return null;
}